import React from 'react';
import { Spinner } from 'reactstrap';
import { useSelector } from 'react-redux';

import { RootState } from 'store/root-reducer';

import 'styles/disabling-spinner.scss';

const DisablingSpinner = (): JSX.Element => {
    const { isDisablingSpinnerVisible } = useSelector((state: RootState) => state.globalElements);

    return isDisablingSpinnerVisible ? (
        <div className={'disabling-spinner'}>
            <Spinner />
        </div>
    ) : null;
};

export default DisablingSpinner;
